const countries = [
  {
    name: 'Afghanistan',
    cca2: 'AF',
  },
  {
    name: 'Åland Islands',
    cca2: 'AX',
  },
  {
    name: 'Albania',
    cca2: 'AL',
  },
  {
    name: 'Algeria',
    cca2: 'DZ',
  },
  {
    name: 'American Samoa',
    cca2: 'AS',
  },
  {
    name: 'Andorra',
    cca2: 'AD',
  },
  {
    name: 'Angola',
    cca2: 'AO',
  },
  {
    name: 'Anguilla',
    cca2: 'AI',
  },
  {
    name: 'Antarctica',
    cca2: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    cca2: 'AG',
  },
  {
    name: 'Argentina',
    cca2: 'AR',
  },
  {
    name: 'Armenia',
    cca2: 'AM',
  },
  {
    name: 'Aruba',
    cca2: 'AW',
  },
  {
    name: 'Australia',
    cca2: 'AU',
  },
  {
    name: 'Austria',
    cca2: 'AT',
  },
  {
    name: 'Azerbaijan',
    cca2: 'AZ',
  },
  {
    name: 'Bahamas',
    cca2: 'BS',
  },
  {
    name: 'Bahrain',
    cca2: 'BH',
  },
  {
    name: 'Bangladesh',
    cca2: 'BD',
  },
  {
    name: 'Barbados',
    cca2: 'BB',
  },
  {
    name: 'Belarus',
    cca2: 'BY',
  },
  {
    name: 'Belgium',
    cca2: 'BE',
  },
  {
    name: 'Belize',
    cca2: 'BZ',
  },
  {
    name: 'Benin',
    cca2: 'BJ',
  },
  {
    name: 'Bermuda',
    cca2: 'BM',
  },
  {
    name: 'Bhutan',
    cca2: 'BT',
  },
  {
    name: 'Bolivia',
    cca2: 'BO',
  },
  {
    name: 'Bonaire',
    cca2: 'BQ',
  },
  {
    name: 'Bosnia and Herzegovina',
    cca2: 'BA',
  },
  {
    name: 'Botswana',
    cca2: 'BW',
  },
  {
    name: 'Bouvet Island',
    cca2: 'BV',
  },
  {
    name: 'Brazil',
    cca2: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    cca2: 'IO',
  },
  {
    name: 'British Virgin Islands',
    cca2: 'VG',
  },
  {
    name: 'Brunei',
    cca2: 'BN',
  },
  {
    name: 'Bulgaria',
    cca2: 'BG',
  },
  {
    name: 'Burkina Faso',
    cca2: 'BF',
  },
  {
    name: 'Burundi',
    cca2: 'BI',
  },
  {
    name: 'Cambodia',
    cca2: 'KH',
  },
  {
    name: 'Cameroon',
    cca2: 'CM',
  },
  {
    name: 'Canada',
    cca2: 'CA',
  },
  {
    name: 'Cape Verde',
    cca2: 'CV',
  },
  {
    name: 'Cayman Islands',
    cca2: 'KY',
  },
  {
    name: 'Central African Republic',
    cca2: 'CF',
  },
  {
    name: 'Chad',
    cca2: 'TD',
  },
  {
    name: 'Chile',
    cca2: 'CL',
  },
  {
    name: 'China',
    cca2: 'CN',
  },
  {
    name: 'Christmas Island',
    cca2: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    cca2: 'CC',
  },
  {
    name: 'Colombia',
    cca2: 'CO',
  },
  {
    name: 'Comoros',
    cca2: 'KM',
  },
  {
    name: 'Republic of the Congo',
    cca2: 'CG',
  },
  {
    name: 'Democratic Republic of the Congo',
    cca2: 'CD',
  },
  {
    name: 'Cook Islands',
    cca2: 'CK',
  },
  {
    name: 'Costa Rica',
    cca2: 'CR',
  },
  {
    name: 'Croatia',
    cca2: 'HR',
  },
  {
    name: 'Cuba',
    cca2: 'CU',
  },
  {
    name: 'Curaçao',
    cca2: 'CW',
  },
  {
    name: 'Cyprus',
    cca2: 'CY',
  },
  {
    name: 'Czech Republic',
    cca2: 'CZ',
  },
  {
    name: 'Denmark',
    cca2: 'DK',
  },
  {
    name: 'Djibouti',
    cca2: 'DJ',
  },
  {
    name: 'Dominica',
    cca2: 'DM',
  },
  {
    name: 'Dominican Republic',
    cca2: 'DO',
  },
  {
    name: 'Ecuador',
    cca2: 'EC',
  },
  {
    name: 'Egypt',
    cca2: 'EG',
  },
  {
    name: 'El Salvador',
    cca2: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    cca2: 'GQ',
  },
  {
    name: 'Eritrea',
    cca2: 'ER',
  },
  {
    name: 'Estonia',
    cca2: 'EE',
  },
  {
    name: 'Ethiopia',
    cca2: 'ET',
  },
  {
    name: 'Falkland Islands',
    cca2: 'FK',
  },
  {
    name: 'Faroe Islands',
    cca2: 'FO',
  },
  {
    name: 'Fiji',
    cca2: 'FJ',
  },
  {
    name: 'Finland',
    cca2: 'FI',
  },
  {
    name: 'France',
    cca2: 'FR',
  },
  {
    name: 'French Guiana',
    cca2: 'GF',
  },
  {
    name: 'French Polynesia',
    cca2: 'PF',
  },
  {
    name: 'French Southern and Antarctic Lands',
    cca2: 'TF',
  },
  {
    name: 'Gabon',
    cca2: 'GA',
  },
  {
    name: 'Gambia',
    cca2: 'GM',
  },
  {
    name: 'Georgia',
    cca2: 'GE',
  },
  {
    name: 'Germany',
    cca2: 'DE',
  },
  {
    name: 'Ghana',
    cca2: 'GH',
  },
  {
    name: 'Gibraltar',
    cca2: 'GI',
  },
  {
    name: 'Greece',
    cca2: 'GR',
  },
  {
    name: 'Greenland',
    cca2: 'GL',
  },
  {
    name: 'Grenada',
    cca2: 'GD',
  },
  {
    name: 'Guadeloupe',
    cca2: 'GP',
  },
  {
    name: 'Guam',
    cca2: 'GU',
  },
  {
    name: 'Guatemala',
    cca2: 'GT',
  },
  {
    name: 'Guernsey',
    cca2: 'GG',
  },
  {
    name: 'Guinea',
    cca2: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    cca2: 'GW',
  },
  {
    name: 'Guyana',
    cca2: 'GY',
  },
  {
    name: 'Haiti',
    cca2: 'HT',
  },
  {
    name: 'Heard Island and McDonald Islands',
    cca2: 'HM',
  },
  {
    name: 'Vatican City',
    cca2: 'VA',
  },
  {
    name: 'Honduras',
    cca2: 'HN',
  },
  {
    name: 'Hong Kong',
    cca2: 'HK',
  },
  {
    name: 'Hungary',
    cca2: 'HU',
  },
  {
    name: 'Iceland',
    cca2: 'IS',
  },
  {
    name: 'India',
    cca2: 'IN',
  },
  {
    name: 'Indonesia',
    cca2: 'ID',
  },
  {
    name: 'Ivory Coast',
    cca2: 'CI',
  },
  {
    name: 'Iran',
    cca2: 'IR',
  },
  {
    name: 'Iraq',
    cca2: 'IQ',
  },
  {
    name: 'Ireland',
    cca2: 'IE',
  },
  {
    name: 'Isle of Man',
    cca2: 'IM',
  },
  {
    name: 'Israel',
    cca2: 'IL',
  },
  {
    name: 'Italy',
    cca2: 'IT',
  },
  {
    name: 'Jamaica',
    cca2: 'JM',
  },
  {
    name: 'Japan',
    cca2: 'JP',
  },
  {
    name: 'Jersey',
    cca2: 'JE',
  },
  {
    name: 'Jordan',
    cca2: 'JO',
  },
  {
    name: 'Kazakhstan',
    cca2: 'KZ',
  },
  {
    name: 'Kenya',
    cca2: 'KE',
  },
  {
    name: 'Kiribati',
    cca2: 'KI',
  },
  {
    name: 'Kuwait',
    cca2: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    cca2: 'KG',
  },
  {
    name: 'Laos',
    cca2: 'LA',
  },
  {
    name: 'Latvia',
    cca2: 'LV',
  },
  {
    name: 'Lebanon',
    cca2: 'LB',
  },
  {
    name: 'Lesotho',
    cca2: 'LS',
  },
  {
    name: 'Liberia',
    cca2: 'LR',
  },
  {
    name: 'Libya',
    cca2: 'LY',
  },
  {
    name: 'Liechtenstein',
    cca2: 'LI',
  },
  {
    name: 'Lithuania',
    cca2: 'LT',
  },
  {
    name: 'Luxembourg',
    cca2: 'LU',
  },
  {
    name: 'Macau',
    cca2: 'MO',
  },
  {
    name: 'Macedonia',
    cca2: 'MK',
  },
  {
    name: 'Madagascar',
    cca2: 'MG',
  },
  {
    name: 'Malawi',
    cca2: 'MW',
  },
  {
    name: 'Malaysia',
    cca2: 'MY',
  },
  {
    name: 'Maldives',
    cca2: 'MV',
  },
  {
    name: 'Mali',
    cca2: 'ML',
  },
  {
    name: 'Malta',
    cca2: 'MT',
  },
  {
    name: 'Marshall Islands',
    cca2: 'MH',
  },
  {
    name: 'Martinique',
    cca2: 'MQ',
  },
  {
    name: 'Mauritania',
    cca2: 'MR',
  },
  {
    name: 'Mauritius',
    cca2: 'MU',
  },
  {
    name: 'Mayotte',
    cca2: 'YT',
  },
  {
    name: 'Mexico',
    cca2: 'MX',
  },
  {
    name: 'Micronesia',
    cca2: 'FM',
  },
  {
    name: 'Moldova',
    cca2: 'MD',
  },
  {
    name: 'Monaco',
    cca2: 'MC',
  },
  {
    name: 'Mongolia',
    cca2: 'MN',
  },
  {
    name: 'Montenegro',
    cca2: 'ME',
  },
  {
    name: 'Montserrat',
    cca2: 'MS',
  },
  {
    name: 'Morocco',
    cca2: 'MA',
  },
  {
    name: 'Mozambique',
    cca2: 'MZ',
  },
  {
    name: 'Myanmar',
    cca2: 'MM',
  },
  {
    name: 'Namibia',
    cca2: 'NA',
  },
  {
    name: 'Nauru',
    cca2: 'NR',
  },
  {
    name: 'Nepal',
    cca2: 'NP',
  },
  {
    name: 'Netherlands',
    cca2: 'NL',
  },
  {
    name: 'New Caledonia',
    cca2: 'NC',
  },
  {
    name: 'New Zealand',
    cca2: 'NZ',
  },
  {
    name: 'Nicaragua',
    cca2: 'NI',
  },
  {
    name: 'Niger',
    cca2: 'NE',
  },
  {
    name: 'Nigeria',
    cca2: 'NG',
  },
  {
    name: 'Niue',
    cca2: 'NU',
  },
  {
    name: 'Norfolk Island',
    cca2: 'NF',
  },
  {
    name: 'North Korea',
    cca2: 'KP',
  },
  {
    name: 'Northern Mariana Islands',
    cca2: 'MP',
  },
  {
    name: 'Norway',
    cca2: 'NO',
  },
  {
    name: 'Oman',
    cca2: 'OM',
  },
  {
    name: 'Pakistan',
    cca2: 'PK',
  },
  {
    name: 'Palau',
    cca2: 'PW',
  },
  {
    name: 'Palestine',
    cca2: 'PS',
  },
  {
    name: 'Panama',
    cca2: 'PA',
  },
  {
    name: 'Papua New Guinea',
    cca2: 'PG',
  },
  {
    name: 'Paraguay',
    cca2: 'PY',
  },
  {
    name: 'Peru',
    cca2: 'PE',
  },
  {
    name: 'Philippines',
    cca2: 'PH',
  },
  {
    name: 'Pitcairn Islands',
    cca2: 'PN',
  },
  {
    name: 'Poland',
    cca2: 'PL',
  },
  {
    name: 'Portugal',
    cca2: 'PT',
  },
  {
    name: 'Puerto Rico',
    cca2: 'PR',
  },
  {
    name: 'Qatar',
    cca2: 'QA',
  },
  {
    name: 'Republic of Kosovo',
    cca2: 'XK',
  },
  {
    name: 'Réunion',
    cca2: 'RE',
  },
  {
    name: 'Romania',
    cca2: 'RO',
  },
  {
    name: 'Russia',
    cca2: 'RU',
  },
  {
    name: 'Rwanda',
    cca2: 'RW',
  },
  {
    name: 'Saint Barthélemy',
    cca2: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    cca2: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    cca2: 'KN',
  },
  {
    name: 'Saint Lucia',
    cca2: 'LC',
  },
  {
    name: 'Saint Martin',
    cca2: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    cca2: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    cca2: 'VC',
  },
  {
    name: 'Samoa',
    cca2: 'WS',
  },
  {
    name: 'San Marino',
    cca2: 'SM',
  },
  {
    name: 'São Tomé and Príncipe',
    cca2: 'ST',
  },
  {
    name: 'Saudi Arabia',
    cca2: 'SA',
  },
  {
    name: 'Senegal',
    cca2: 'SN',
  },
  {
    name: 'Serbia',
    cca2: 'RS',
  },
  {
    name: 'Seychelles',
    cca2: 'SC',
  },
  {
    name: 'Sierra Leone',
    cca2: 'SL',
  },
  {
    name: 'Singapore',
    cca2: 'SG',
  },
  {
    name: 'Sint Maarten',
    cca2: 'SX',
  },
  {
    name: 'Slovakia',
    cca2: 'SK',
  },
  {
    name: 'Slovenia',
    cca2: 'SI',
  },
  {
    name: 'Solomon Islands',
    cca2: 'SB',
  },
  {
    name: 'Somalia',
    cca2: 'SO',
  },
  {
    name: 'South Africa',
    cca2: 'ZA',
  },
  {
    name: 'South Georgia',
    cca2: 'GS',
  },
  {
    name: 'South Korea',
    cca2: 'KR',
  },
  {
    name: 'South Sudan',
    cca2: 'SS',
  },
  {
    name: 'Spain',
    cca2: 'ES',
  },
  {
    name: 'Sri Lanka',
    cca2: 'LK',
  },
  {
    name: 'Sudan',
    cca2: 'SD',
  },
  {
    name: 'Suriname',
    cca2: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    cca2: 'SJ',
  },
  {
    name: 'Swaziland',
    cca2: 'SZ',
  },
  {
    name: 'Sweden',
    cca2: 'SE',
  },
  {
    name: 'Switzerland',
    cca2: 'CH',
  },
  {
    name: 'Syria',
    cca2: 'SY',
  },
  {
    name: 'Taiwan',
    cca2: 'TW',
  },
  {
    name: 'Tajikistan',
    cca2: 'TJ',
  },
  {
    name: 'Tanzania',
    cca2: 'TZ',
  },
  {
    name: 'Thailand',
    cca2: 'TH',
  },
  {
    name: 'Timor-Leste',
    cca2: 'TL',
  },
  {
    name: 'Togo',
    cca2: 'TG',
  },
  {
    name: 'Tokelau',
    cca2: 'TK',
  },
  {
    name: 'Tonga',
    cca2: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    cca2: 'TT',
  },
  {
    name: 'Tunisia',
    cca2: 'TN',
  },
  {
    name: 'Turkey',
    cca2: 'TR',
  },
  {
    name: 'Turkmenistan',
    cca2: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    cca2: 'TC',
  },
  {
    name: 'Tuvalu',
    cca2: 'TV',
  },
  {
    name: 'Uganda',
    cca2: 'UG',
  },
  {
    name: 'Ukraine',
    cca2: 'UA',
  },
  {
    name: 'United Arab Emirates',
    cca2: 'AE',
  },
  {
    name: 'United Kingdom',
    cca2: 'GB',
  },
  {
    name: 'United States',
    cca2: 'US',
  },
  {
    name: 'United States Minor Outlying Islands',
    cca2: 'UM',
  },
  {
    name: 'United States Virgin Islands',
    cca2: 'VI',
  },
  {
    name: 'Uruguay',
    cca2: 'UY',
  },
  {
    name: 'Uzbekistan',
    cca2: 'UZ',
  },
  {
    name: 'Vanuatu',
    cca2: 'VU',
  },
  {
    name: 'Venezuela',
    cca2: 'VE',
  },
  {
    name: 'Vietnam',
    cca2: 'VN',
  },
  {
    name: 'Wallis and Futuna',
    cca2: 'WF',
  },
  {
    name: 'Western Sahara',
    cca2: 'EH',
  },
  {
    name: 'Yemen',
    cca2: 'YE',
  },
  {
    name: 'Zambia',
    cca2: 'ZM',
  },
  {
    name: 'Zimbabwe',
    cca2: 'ZW',
  },
];

export default countries;
